module.exports = __webpack_public_path__ + "static/media/Happy_Fishing.6bf444a3.png";